import styled from "@emotion/styled";
import { AddCircleOutline } from "@mui/icons-material";
import { Icon, IconButton, Toolbar, Typography } from "@mui/material";
import clsx from "clsx";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Can } from "../HOC/CustomComponents/Secured";
import PrintIcon from "../Shipments/PrintIcon";
import PrintComponent from "../Shipments/PrintComponent";

const PREFIX = "ManifestTableToolbar";

const classes = {
  titles: `${PREFIX}-titles`,
  addIcon: `${PREFIX}-addIcon`,
};
const Root = styled(Toolbar)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(1),
  [`& .${classes.titles}`]: {
    flex: "1 1 100%",
  },

  [`& .${classes.addIcon}`]: {
    color: theme.palette.success.main,
  },
}));
//*********Table Function*********
const EnhancedTableToolbar = (props) => {
  const { selectedShipment, addShipment, disabledAddIcon, barcode } = props;

  const { t } = useTranslation();

  const shipmentId = selectedShipment.map((i) => i.id);
  return (
    <Root className={clsx(classes.root)}>
      <Typography
        className={classes.titles}
        color="inherit"
        variant="subtitle1"
        component="div"
      >
        {t("shipmentsNumber") + " " + selectedShipment.length}
      </Typography>
      {addShipment && (
        <IconButton
          aria-label="Add"
          className={classes.addIcon}
          onClick={addShipment}
          disabled={disabledAddIcon}
          size="large"
        >
          <AddCircleOutline />
        </IconButton>
      )}
      {barcode ? (
        <IconButton aria-label="Add" onClick={barcode} size="large">
          <Icon>qr_code_scanner</Icon>
        </IconButton>
      ) : null}
      <Can showException permission="shipping.shipment.print">
        <PrintComponent shipmentsId={shipmentId} />
      </Can>
    </Root>
  );
};

EnhancedTableToolbar.propTypes = {
  selectedShipment: PropTypes.array.isRequired,
};

export default EnhancedTableToolbar;
